import types from '@/vuex/administracao/edicao-tipo-documental/actions-types'
import administracao from '@/utils/administracao'

const actions = {
  [types.BUSCA_TIPOS_DOCUMENTAIS]: async ({ commit }) => {
    try {
      commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando tipos documentais' }, {root: true})
      commit(types.SET_TIPO_SELECIONADO, { idTipoSelecionado: undefined })
      const response = await administracao.buscaTodosTiposDocumento()
      response.body.sort(function (a, b) {
        var textA = a.descricao.toUpperCase()
        var textB = b.descricao.toUpperCase()
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
      })
      commit(types.SET_LISTA_TIPOS_DOCUMENTAIS, { listaTiposDocumentais: response.body })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar os tipos documentais' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando tipos documentais' }, {root: true})
    }
  },
  [types.SELECIONA_TIPO_DOCUMENTAL]: async ({ commit }, payload) => {
    commit(types.SET_TIPO_SELECIONADO, { idTipoSelecionado: payload.idTipoSelecionado })
  },
  [types.ALTERA_PROPRIEDADE_TIPO_DOCUMENTAL]: async ({ commit }, payload) => {
    try {
      commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Alterando propriedade' }, {root: true})
      await administracao.alteraPropriedadeTipoDocumental(payload.idTipoDocumento, payload.propriedade)
      commit(types.SET_PROPRIEDADES, payload)
      commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Propriedades do tipo documental alteradas com sucesso' }, {root: true})
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Erro ao alterar propriedades' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Alterando propriedades' }, {root: true})
    }
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/vuex/administracao/edicao-tipo-documental/actions.js